import CaSyncErrors from "../modules/CaSyncErrors/CaSyncErrors";
import { AdminMenuLayout } from "../shared/components";

export function CaSyncErrorsPage() {
  return (
    <AdminMenuLayout title="" pageDescription="">
     <CaSyncErrors/>
    </AdminMenuLayout>
  );
}
